export const FETCH_PAYERS = 'PAYERS/FETCH_PAYERS_REQUEST';
export const FETCH_PAYERS_SUCCESS = 'PAYERS/FETCH_PAYERS_SUCCESS';

export const FETCH_AVAILABLE_PAYERS = 'PAYERS/FETCH_AVAILABLE_REQUEST';
export const FETCH_AVAILABLE_PAYERS_SUCCESS = 'PAYERS/FETCH_AVAILABLE_SUCCESS';

export const FETCH_PAYER = 'PAYERS/FETCH_REQUEST';
export const FETCH_PAYER_SUCCESS = 'PAYERS/FETCH_SUCCESS';

export const PUT_PAYER = 'PAYER/PUT_REQUEST';
export const PUT_PAYER_SUCCESS = 'PAYER/PUT_SUCCESS';

export const POST_PAYER = 'PAYER/POST_REQUEST';
export const POST_PAYER_SUCCESS = 'PAYER/POST_SUCCESS';

export const DELETE_PAYER = 'PAYER/DELETE_REQUEST';
export const DELETE_PAYER_SUCCESS = 'PAYER/DELETE_SUCCESS';
export const DELETE_PAYER_FAILURE = 'PAYER/DELETE_FAILURE';

export const SET_PAYERS_DASHBOARD_FILTER = 'PAYERS/DASHBOARD/FILTER/SET';
export const CLEAR_PAYERS_DASHBOARD_FILTER = 'PAYERS/DASHBOARD/FILTERS/CLEAR';
export const REMOVE_PAYERS_DASHBOARD_FILTER = 'PAYERS/DASHBOARD/FILTERS/REMOVE';

export const FILTER_PAYERS = 'PAYERS/FILTER_PAYERS_REQUEST';
export const FILTER_PAYERS_SUCCESS = 'PAYERS/FILTER_PAYERS_SUCCESS';
export const SET_IS_READY = 'PAYERS/DETAILS/SET_IS_READY';
